import { OktaAuth } from '@okta/okta-auth-js';
import { env } from './env';

const oktaAuth = new OktaAuth({
  issuer: env.OKTA_ISSUER,
  clientId: env.OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/completeLogin`,
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email', 'groups', 'offline_access'],
  pkce: true,
});

export default oktaAuth;
